import { render, staticRenderFns } from "./CreateClockEntry.vue?vue&type=template&id=52a8607a&scoped=true"
import script from "./CreateClockEntry.vue?vue&type=script&lang=js"
export * from "./CreateClockEntry.vue?vue&type=script&lang=js"
import style0 from "./CreateClockEntry.vue?vue&type=style&index=0&id=52a8607a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a8607a",
  null
  
)

export default component.exports